"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformArguments = void 0;
function transformArguments(key) {
    return ['CLUSTER', 'KEYSLOT', key];
}
exports.transformArguments = transformArguments;
